import React, { Component } from 'react';
import InputRange from 'react-input-range';

import PropTypes from 'prop-types';

import './DeepSearchInputRange.scss';

export default class DeepSearchInputRange extends Component {
  static propTypes = {
    field: PropTypes.string,
    setInputRange: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    maxRange: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }),
    formatLabel: PropTypes.func,
    hideLabel: PropTypes.bool
  };

  static defaultProps = {
    maxRange: { min: 0, max: 100 }
  };

  state = { isDirty: false };

  isInitialRange = (min, max) => {
    const { maxRange } = this.props;

    return min <= maxRange.min && max >= maxRange.max;
  };

  sliderColor = (min, max) =>
    this.isInitialRange(min, max)
      ? 'input-range__slider--initial'
      : 'input-range__slider--move';

  barColor = (min, max) =>
    this.isInitialRange(min, max)
      ? 'input-range__track--initial'
      : 'input-range__track--active';

  classNames(min, max) {
    const { hideLabel, maxRange } = this.props;
    const { isDirty } = this.state;

    const isInitialMinEqualsMaxRange = !isDirty && min === maxRange.max;
    const shouldAvoidStuckAtMax = isInitialMinEqualsMaxRange
      ? ' input-range__min--ahead'
      : '';

    return {
      activeTrack: `input-range__track ${this.barColor(min, max)}`,
      disabledInputRange: 'input-range input-range--disabled',
      inputRange: 'input-range',
      labelContainer: !hideLabel
        ? 'input-range__label-container'
        : 'input-range__label-container--hidden',
      maxLabel: 'input-range__label input-range__label--max',
      minLabel: 'input-range__label input-range__label--min',
      slider: `input-range__slider ${this.sliderColor(min, max)}`,
      sliderContainer: `input-range__slider-container${shouldAvoidStuckAtMax}`,
      track: 'input-range__track input-range__track--background',
      valueLabel: 'input-range__label input-range__label--value'
    };
  }

  onChange = (value) => {
    const { field, setInputRange, maxRange } = this.props;
    const max = value.max > maxRange.max ? maxRange.max : value.max;
    const min = value.min < maxRange.min ? maxRange.min : value.min;

    setInputRange(field, { max, min });
    this.setState({ isDirty: true });
  };

  render() {
    const { min, max, formatLabel, maxRange } = this.props;
    const value = { min, max };

    return (
      <InputRange
        allowSameValues
        formatLabel={formatLabel}
        maxValue={maxRange.max}
        minValue={maxRange.min}
        value={value}
        onChange={this.onChange}
        classNames={this.classNames(min, max, value)}
      />
    );
  }
}
